import { Outlet } from "react-router-dom";
import styles from './CustomerPublicLayout.module.scss';
import  Slider, { Slide } from "./slider/Slider";


export const slidesData: Slide[] = [
  {
    titleRow1: "Simple, Secure",
    titleRow2: "Electricity Management",
    subText: 'Buy units and manage power from one trusted app',
    gradient: "linear-gradient(0deg, #00273B 0%, #006BA1 100%)",
    image: "/images/ekedc/slider-1.png",
    gif: "/images/ekedc/creative-idea.gif",
    gifPosition: "right"
  },
  {
    titleRow1: "Low On Units?",
    titleRow2: "No Wahala",
    subText: 'Transfer units between meters or use Borrow Units for instant top-ups.',
    gradient: "linear-gradient(0deg, #00273B 0%, #006BA1 100%)",
    image: "/images/ekedc/slider-2.jpg"
  },
  {
    titleRow1: "Stop Typing Long Token Codes",
    titleRow2: "",
    subText: 'Turn on Remote Loading, and units go straight to your meter automatically.',
    gradient: "linear-gradient(0deg, #00273B 0%, #006BA1 100%)",
    image: "/images/ekedc/slider-3.png",
    gif: "/images/ekedc/electricity.gif",
    gifPosition: "left"
  },
  {
    titleRow1: "Track and Pay",
    titleRow2: "Issued Bills",
    subText: 'See what you owe and settle your outstanding bills from one dashboard.',
    gradient: "linear-gradient(0deg, #00273B 0%, #006BA1 100%)",
    image: "/images/ekedc/slider-4.jpg"
  }

];

export const CustomerPublicLayout = () => {
  console.log('customer public layout')
  return (
    <div className={styles.container}>
        <div className={styles.leftPanel}>
          <Slider slides={slidesData} />
        </div>
        <div className={styles.rightPanel}>
          <Outlet />
        </div>
      </div>
  );
};
